/* @flow */
/* eslint-env es6,browser */

import _idpbase from './idpbase';
import { IDP_COMMONID } from './idpconstants';

import { getCookie, setCookie, deleteCookie } from '../utils/cookie';
import storage from '../utils/storage';
import { generateUUID } from '../utils';

const COMMON_ID_KEY = '_pubcid';
const COMMON_ID_OPTOUT_COOKIE_KEY = '_pubcid_optout';

/**
 * @description Implements functionality accessing Publisher Common Id - http://prebid.org/dev-docs/modules/pubCommonId.html
 * @module commonid
 * @requires module:utils
 * @requires module:storage
 * @requires module:cookie
 */

class _commonid extends _idpbase {
  /**
   * Check if user is opted out based on cookie
   *
   * @returns {boolean} - Opt-out status
   */
  _isOptedOut(): boolean {
    return getCookie(COMMON_ID_OPTOUT_COOKIE_KEY).length > 0;
  }

  /**
   * Remove commonID from everywhere
   *
   * @returns {void}
   */
  _removeCommonId(): void {
    // If the user has opted out then return empty id and remove existing pubcid
    storage.remove(COMMON_ID_KEY);
    deleteCookie(COMMON_ID_KEY);
    this._cachedID = '';
  }

  /**
   * @description Helper to common id of the user
   * @returns {string} - common id value
   */
  _refreshID(): string {
    let commonId = '';
    if (this._isOptedOut()) {
      // If the user has opted out then return empty id and remove existing pubcid
      this._removeCommonId();
      return commonId;
    }
    if (this._cachedID && this._cachedID.length) {
      // If cached value is available use it
      return this._cachedID;
    }
    const storageId = storage.get(COMMON_ID_KEY);
    const cookieId = getCookie(COMMON_ID_KEY);
    // Check in cookie and then in local storage. If not found, create a new UID and store in them
    if (cookieId.length) {
      commonId = cookieId;
    } else if (storageId.length) {
      commonId = storageId;
      setCookie(
        COMMON_ID_KEY,
        commonId,
        this._doc,
        this._nExpireDays * 24 * 60 * 60
      );
    } else {
      commonId = generateUUID();
      storage.store(COMMON_ID_KEY, commonId);
      setCookie(
        COMMON_ID_KEY,
        commonId,
        this._doc,
        this._nExpireDays * 24 * 60 * 60
      );
    }
    this._cachedID = commonId;
    return commonId;
  }
}

const cid: _commonid = new _commonid(IDP_COMMONID);
export default cid;
